import axios from 'axios';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import getAxiosConfig from '../helpers/getAxiosConfig';
import getCurrentTreeContentParams from '../helpers/getCurrentTreeContentParams';
import getCurrentTreeContentTransform from '../helpers/getCurrentTreeContentTransform';
import handleAdminVideoAxiosError from '../helpers/handleAdminVideoAxiosError';

export default ({ isTopicsPage, isInSearchContext, setIsShowingLoadingWheel = () => null }) => {
  const location = useLocation();
  const params = useParams();
  const isLiveVideo = params.type === 'live';

  const { url: currentTreeContentPath } = getCurrentTreeContentParams({
    isTopicsPage,
    isInSearchContext,
    location,
    params,
  });

  const currentTreeContentKey = ['currentTreeContent', currentTreeContentPath];
  const currentTreeContent = useQuery(
    currentTreeContentKey,
    async () => {
      let results;
      try {
        const { data } = await axios(
          getAxiosConfig('get-current-tree-content', { currentTreeContentPath }),
        );
        results = isInSearchContext
          ? { items: data.data }
          : getCurrentTreeContentTransform({ data, isLiveVideo });
      } catch (error) {
        results = { items: {} };
        handleAdminVideoAxiosError(error);
      }
      setIsShowingLoadingWheel(false);
      return results;
    },
    {
      placeholderData: { items: {} },
    },
  );

  return { currentTreeContent, currentTreeContentKey };
};
